import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import withGS from '../withGShoc';

class QueryParameterDisplay extends React.Component {

    render() {

        const { data, defaultLang } = this.props;
        const description = data.description ? data.description[defaultLang] : "";

        return (
            <div>
                <Typography data-test="required" variant="caption">{data.optional ? "Optional" : "Required"}</Typography>
                {description.split("\n").map((reportLine, index) =>
                    <Typography key={"line-" + index} data-test={"parameter-entry-description-line-" + index} variant="body2">{reportLine}</Typography>
                )}
            </div>
        );
    }
}

QueryParameterDisplay.defaultProps = {
    isReadOnly: true,
    reportOption: false
};

QueryParameterDisplay.propTypes = {
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(withGS(QueryParameterDisplay));